import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { LogEntry } from "../logEntry";
import { LogPublisher } from "./log-publisher";

export class LogLocalStorage extends LogPublisher {
    
    constructor() {
        super();  // Must call `super()`from derived classes
        this.location = "logging"; // Set location
    }
    
    // Append log entry to local storage
    log(entry: LogEntry): Observable<boolean> {
        let ret: boolean = false;
        let values: LogEntry[];
        
        try {
            // Get previous values from local storage
            values = JSON.parse(localStorage.getItem(this.location)) || [];
            
            // Add new log entry to array
            values.push(entry);
            
            // Store array into local storage
            localStorage.setItem(this.location, JSON.stringify(values));
            
            // Set return value
            ret = true;
        } catch (ex) {
            // Display error in console
            console.log(ex);
        }
        
        return of(ret);
    }
    
    // Clear all log entries from local storage
    clear(): Observable<boolean> {
        localStorage.removeItem(this.location);
        return of(true);
    }
}
